const TRUST_ITEMS = [
  { icon: 'ri-shield-check-line', label: 'Fully Insured & Bonded' },
  { icon: 'ri-group-star-line', label: 'Background-Checked Staff' },
  { icon: 'ri-time-line', label: '24/7 Flexible Scheduling' },
  { icon: 'ri-map-pin-2-line', label: 'Greater Houston Service Area' },
  { icon: 'ri-star-fill', label: '4.8★ Google Rating' },
  { icon: 'ri-award-line', label: '15+ Years Experience' },
];

const INDUSTRIES = [
  'Corporate Offices',
  'Medical Facilities',
  'Hotels & Hospitality',
  'Retail Spaces',
  'Industrial Buildings',
  'Schools & Institutions',
  'Restaurants',
  'Event Venues',
];

export default function TrustBar() {
  return (
    <div>
      {/* Primary trust row */}
      <section className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-5">
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {TRUST_ITEMS.map((item, i) => (
              <div key={i} className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center bg-[#C70532]/8 rounded-lg">
                  <i className={`${item.icon} text-[#C70532] text-base`} />
                </div>
                <span className="text-[#03143A] text-sm font-semibold whitespace-nowrap">{item.label}</span>
                {i < TRUST_ITEMS.length - 1 && <span className="hidden md:inline-block w-px h-4 bg-gray-200 ml-4" />}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries served ticker */}
      <section className="bg-[#03143A] py-3 overflow-hidden">
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0 px-6 flex items-center gap-2">
            <i className="ri-building-4-line text-[#C70532] text-sm" />
            <span className="text-white/60 text-xs font-bold uppercase tracking-widest whitespace-nowrap">Industries Served:</span>
          </div>
          <div className="flex items-center gap-8 animate-marquee overflow-hidden">
            {[...INDUSTRIES, ...INDUSTRIES].map((ind, i) => (
              <span key={i} className="text-white/70 text-sm font-medium whitespace-nowrap flex items-center gap-2">
                <span className="w-1 h-1 rounded-full bg-[#C70532] flex-shrink-0 inline-block" />
                {ind}
              </span>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
